import { createSlice } from "@reduxjs/toolkit";
import {
  fetchQrAttendanceLogs,
  fetchQrTerminals,
  manualOpenAttendance,
  manualCompleteAttendance,
  fetchIncompleteAttendanceLogs,
} from "./qrAttendanceLogsThunks";

export const QrAttendanceMethod = {
  MobileQr: 1,
  Card: 2,
  Manual: 3,
};

export const QrAttendanceMethodLabels = {
  1: "Mobil QR",
  2: "Kart",
  3: "Manuel",
};

const initialState = {
  logs: [],
  incompleteLogs: [],
  terminals: [],
  loading: false,
  submitting: false,
  error: null,
  successMessage: null,
};

const qrAttendanceLogsSlice = createSlice({
  name: "qrAttendanceLogs",
  initialState,
  reducers: {
    clearStatus: (state) => {
      state.error = null;
      state.successMessage = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchQrAttendanceLogs
      .addCase(fetchQrAttendanceLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQrAttendanceLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.logs = Array.isArray(action.payload) ? action.payload : action.payload?.items || [];
      })
      .addCase(fetchQrAttendanceLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // fetchIncompleteAttendanceLogs
      .addCase(fetchIncompleteAttendanceLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchIncompleteAttendanceLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.incompleteLogs = Array.isArray(action.payload) ? action.payload : action.payload?.items || [];
      })
      .addCase(fetchIncompleteAttendanceLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // fetchQrTerminals
      .addCase(fetchQrTerminals.fulfilled, (state, action) => {
        state.terminals = Array.isArray(action.payload) ? action.payload : action.payload?.items || [];
      })

      // manualOpenAttendance
      .addCase(manualOpenAttendance.pending, (state) => {
        state.submitting = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(manualOpenAttendance.fulfilled, (state) => {
        state.submitting = false;
        state.successMessage = "Manuel giriş kaydı başarıyla oluşturuldu.";
      })
      .addCase(manualOpenAttendance.rejected, (state, action) => {
        state.submitting = false;
        state.error = action.payload;
      })

      // manualCompleteAttendance
      .addCase(manualCompleteAttendance.pending, (state) => {
        state.submitting = true;
        state.error = null;
        state.successMessage = null;
      })
      .addCase(manualCompleteAttendance.fulfilled, (state) => {
        state.submitting = false;
        state.successMessage = "Manuel çıkış kaydı başarıyla tamamlandı.";
      })
      .addCase(manualCompleteAttendance.rejected, (state, action) => {
        state.submitting = false;
        state.error = action.payload;
      });
  },
});

export const { clearStatus } = qrAttendanceLogsSlice.actions;
export default qrAttendanceLogsSlice.reducer;
